import { Box, Typography } from "@mui/material";
import React from "react";
import { PRIMARY_BUTTON_BLUE } from "../colorPalette";

const Logo = ({
    variant = "h2",
    color = PRIMARY_BUTTON_BLUE
}) => {
    return (
        <Box>
            <Typography fontFamily={'poetsen'} variant={variant} sx={{color: color}}>Lumas</Typography>
        </Box>
    )
}

export default Logo